<template>
    <div class="news">
        <el-container>
            <el-aside class="left flex-start column items">
                <div :class="[activeIndex==1 && activeIndexChild==-1?'active':'']" class=" nav flex-center items" @click="activeIndexFun(1)">
                    <img
                        src="../../assets/images/backstageManagement/news_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>信息管理</span>
                </div>
                <div class="nav-child flex-between items" :class="[activeIndexChild==0?'active':'']"  @click="routerFun(0)">
                    <div class="flex-start items">
                        <p class="circle"></p>
                        <span class="text">未发布</span>
                    </div>
                    <span class="num flex-center items" v-if="pages&&activeIndexChild!=0">{{pages}}</span>
                </div>
                <div class="nav-child flex-between items" :class="[activeIndexChild==1?'active':'']" @click="routerFun(1)">
                    <div class="flex-start items">
                        <p class="circle"></p>
                        <span class="text">已发布</span>
                    </div>
                    <span></span>
                    <!-- <span class="num flex-center items">2</span> -->
                </div>
                <div :class="[activeIndex==2?'active':'']" class=" nav flex-center items" @click="activeIndexFun(2)">
                    <img
                        src="../../assets/images/backstageManagement/news1_icon.png"
                        class="icon"
                        alt
                        srcset
                    />
                    <span>栏目配置</span>
                </div>
            </el-aside>
            <el-main class="right">
                <first ref="child" :isPublish='isPublish' v-show="activeIndex == 1"></first>
                <two v-show="activeIndex == 2"></two>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import first from "./subgroup/news_first";
import two from "./subgroup/news_two";
import {
    listByPageArticle
} from "../../api/news.js";
export default {
    components: {
        first,
        two
    },
    data() {
        return {
            search: "",
            activeIndex:1,//当前选择栏目
            activeIndexChild:-1,//子类
            pages:0,
            status:'',
            isPublish:0,
            queryData:{
                currentPage: 1, //当前页
                pageSize: 10,
            },
        };
    },
    created() {
        // this.listByPageFather();
        // this.$refs.firstChild.handleSizeChange(1);
    },
    methods: {
        handleClick(row) {
            //console.log(row);
        },
        activeIndexFun(index){
            if(index != this.activeIndex){
                 this.activeIndex = index
            }
            // if(index==1){
            //     this.$refs.child.listByPageFun('',-1);
            // }
            // this.activeIndexChild = -1
        },
        routerFun (str){
            this.isPublish=str;
            console.log(this.isPublish)
            this.$refs.child.listByPageFun();
            // this.listByPageFather();
            // if(this.activeIndex!=1){
            //     this.activeIndexFun(1);
            // }
            // this.activeIndexChild = str1;
            // this.$refs.child.listByPageFun(str1,-1);
        },
        // isPublish   是否发布(0：未发布，1：已发布)
        // //列表
        // listByPageFather() {
        //     let params={
        //         ...this.queryData,
        //         isPublish:this.isPublish
        //     }
        //     listByPageArticle(params)
        //         .then(res => {
        //             if (res.code == 200) {
        //                 let dataPages = res.data.pages || 0;
        //                 if(this.pages != dataPages){
        //                     this.pages = dataPages
        //                 }
                        
        //             }else{
        //                 this.$message.error(res.message);
        //             }
        //         })
        //         .catch(err => {
        //             this.$message.error(err.message);
        //         });
        // },
    }
};
</script>
<style lang="less" scoped>
.news {
    font-family: "微软雅黑";
    min-height: calc(~"100vh - 60px");
    .el-container {
        min-height: 100%;
    }
    /deep/ .input_box{
        overflow: hidden;
    }
    .left {
        .nav {
            width: 180px;
            height: 40px;
            // margin-right: 10px;
            border-radius: 20px;
            font-size: 16px;
            margin-top: 5px;
            cursor:pointer;
            .icon {
                width: 20px;
                height: 20px;
                margin-right: 12px;
            }
            margin-bottom: 5px;
            margin-right: 10px;
        }
        .nav:first-child{
            margin-top: 0;
        }
        .nav-child {
            // padding-bottom: 10px;
            height: 36px;
            line-height: 36px;
            width: 180px;
            margin-right: 10px;
            border-radius: 18px;
            box-sizing: border-box;
            padding-left: 50px;
            font-size: 15px;
            cursor:pointer;
            .circle {
                width: 8px;
                height: 8px;
                border-radius: 4px;
                border: 1px solid #fff;
                margin-right: 17px;
                box-sizing: border-box;
            }
            .num {
                background: #007eff;
                // width: 20px;
                height: 20px;
                font-size: 13px;
                border-radius: 10px;
                padding: 0 7px;
            }
            .text {
                height: 1em;
                line-height: 1em;
                font-size: 14px;
                width: 65px;
            }
        }
        .active {
            background: rgba(0, 126, 255, 1);
        }
     
    }
    /deep/ img{
        max-height: 200px;
    }
    /deep/ .el-dialog__title {
        color: #0074cc !important;
    }
    /deep/ .first-ruleForm{  
        .block_box{
            display: block;
        }
        
        .el-form-item,.el-input,.el-select {
            width: 100%;
        }
        .block_box_width{
            width: calc(50% - 5px);
        }
        .block_box_width:nth-of-type(odd){
            margin-right: 0;
        }
        .el-form-item__content, .el-form-item__content {
            width: calc(100% - 85px);
        }
    }
    /deep/ .ql-editor {
        min-height: 150px;
    }
    /deep/ .el-dialog__close {
        background: rgba(0, 148, 255, 1);
        border-radius: 4px;
        color: #fff;
    }
    /deep/ .dialog-footer {
        .el-button {
            width: 80px;
            height: 30px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(0, 145, 255, 1);
            box-shadow: 0px 1px 3px 0px rgba(0, 72, 128, 0.3);
            border-radius: 4px;
            padding: 0;
            color:#0091FF;

        }
        .el-button1{
            width:80px;
            height:30px;
            background:rgba(0,126,255,1);
            border:1px solid rgba(0,145,255,1);
            box-shadow:0px 1px 3px 0px rgba(0,72,128,0.3);
            border-radius:4px;
            color: #fff;
            margin-left: 10px;
        }
    }
    /deep/ .el-pagination{
        padding: 0 !important;
    }
}
/deep/ .el-dialog__wrapper{
    z-index: 1001 !important;
}
/deep/ .el-dialog__wrapper, /deep/ .v-modal{
    z-index: 1000 !important;
}
/deep/ .edui-default{
    z-index: 11066!important;

}
.flex-center {
    display: flex;
    justify-content: center;
}
.flex-start {
    display: flex;
    justify-content: flex-start;
}
.items {
    align-items: center;
}
.column {
    flex-direction: column;
}
.flex-between {
    display: flex;
    justify-content: space-between;
}
.flex-end {
    display: flex;
    justify-content: flex-end;
}
</style>
